import React, { Component } from 'react';
import { connect } from 'react-redux';
import SensorByNameView from './SensorByNameView';
import { getPointsByType, getPointsByFloorAndType } from '../../../redux/selectors/equipment';
import { getSearchParams } from '../../../utils/url';
import SensorByFloorView from './SensorByFloorView';
import { compareByNumericProp } from '../../../utils/comparators';

const mapStateToProps = (state, ownProps) => ({
  pointsByType: getPointsByType(state, getSearchParams(ownProps.location.search)),
  pointsByFloorAndType: getPointsByFloorAndType(state, getSearchParams(ownProps.location.search)),
  byLocDisplayOption: state.ui.byLocDisplayOption,
});

const sensorCols = [
  { hideOnMobile: false, name: 'Equipment' },
  { hideOnMobile: false, name: 'Value' },
];

const mapPointsToArray = (byFloor) => {
  const pointsArray = [];
  const floorNames = Object.getOwnPropertyNames(byFloor);
  for (let i = 0; i < floorNames.length; i += 1) {
    const floorName = floorNames[i];
    pointsArray.push({
      floorNum: byFloor[floorName].floorNum,
      name: floorName,
      sortOrder: byFloor[floorName].sortOrder,
      pointsByType: byFloor[floorName].pointsByType,
    });
  }
  pointsArray.sort(compareByNumericProp('sortOrder', 'desc'));
  return pointsArray;
};

class SensorContainer extends Component {
  handlePointTypeSelection(e, pointTypeId, floorNum) {
    let url = `${this.props.location.pathname}/sensor/${this.props.location.search}&ptid=${pointTypeId}`;
    if (floorNum) {
      if (this.props.byLocDisplayOption === 'physlocation') url += `&sFloorPhys=${floorNum}`;
      if (this.props.byLocDisplayOption === 'areaserved') url += `&sFloorServed=${floorNum}`;
    }
    this.props.navigate(url);
  }

  getNameView() {
    return (
      <SensorByNameView
        bid={this.props.bid}
        pointTypes={this.props.pointsByType}
        location={this.props.location}
        handlePointTypeSelection={(e, pointTypeId) => this.handlePointTypeSelection(e, pointTypeId)}
        cols={sensorCols}
      />
    );
  }

  getFloorView() {
    return (
      <SensorByFloorView
        pointTypesByFloor={mapPointsToArray(this.props.pointsByFloorAndType)}
        location={this.props.location}
        handlePointTypeSelection={(e, pointTypeId, floorNum) =>
          this.handlePointTypeSelection(e, pointTypeId, floorNum)
        }
        cols={sensorCols}
      />
    );
  }

  render() {
    if (
      this.props.byLocDisplayOption === 'physlocation' ||
      this.props.byLocDisplayOption === 'areaserved'
    ) {
      return this.getFloorView();
    }
    return this.getNameView();
  }
}

export default connect(mapStateToProps, null)(SensorContainer);
